/**
 * youtube视频链接正则表达式
 * 参考: https://www.codenong.com/3717115/
 */
export const YOUTUBE_LINK_REGEXP =
    "(?:http(?:s)?:\\/\\/)?(?:www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:(?:watch)?\\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user)\\/))([^\\?&\"'<> #]+)";
export const GOOGLE_DRIVE_LINK_REGEXP = "(?:http(?:s)?:\\/\\/)?(dirve\\.google\\.com\\/file\\/d\\/.+)"; //仅需匹配/file/d格式 "(?:http(?:s)?:\\/\\/)?(dirve\\.google\\.com\\/((file\\/d\\/.+)|\\?.+&id=.+|video.*\\/edit\\?id=))";
export const GOOGLE_DOCS_LINK_REGEXP = "(?:http(?:s)?:\\/\\/)?(docs\\.google\\.com\\/document\\/d\\/.+)"; //仅需匹配/document/d格式 "(?:http(?:s)?:\\/\\/)?(dirve\\.google\\.com\\/((file\\/d\\/.+)|\\?.+&id=.+|video.*\\/edit\\?id=))";

export const TIKTOK_LINK_REGEXP =
    "(?:http(s)?://(m|www|vm|vt)?\\.tiktok\\.com/((.*\\b((usr|v|embed|user|video)/|shareId=|&item_id=)(\\d+))|\\w+))";
export const TWITTER_LINK_REGEXP = ".*(x|twitter).com/(?<author>.*)/status(es)?/(?<code>.*)";
export const INS_LINK_REGEXP = "https?:\\/\\/(?:www\\.)?instagram\\.com\\/(?:reel|reels)\\/[A-Za-z0-9-_]+\\/?";
export const regexps = {
    /**
     * 1.密码必须由字母、数字、特殊符号组成，区分大小写
     * 2.特殊符号包含（. _ ~ ! @ # $ ^ & *）
     */
    passwordReg: /^([a-zA-Z0-9\\!\\@\\#\\$\\%\\^\\&\\*\\_]){1,}$/,
};
// 语言符号，拆分段落、句子时的标记
export const LANGUAGE_SYMBOLS = [
    ".",
    "?",
    "!",
    "،",
    "۔",
    "༔",
    "།",
    "，",
    "。",
    ",",
    "।",
    "၊",
    "、",
    "။",
    "๏",
    "؟",
    "！",
    "？",
];
export const LANGUAGE_SYMBOLS_REG = /[.,?!،۔༔།，。।၊、။๏؟！？]/g;
